/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrivateNumberBuyRequestStatus {
  Reserved = 0,
  Pending = 1,
  CertainAssignment = 2,
  Rejected = 3,
  WaitingDocumentsUpload = 4,
  PrivateNumberAlreadyExisted = 5,
  ErrorInAddPrivateNumber = 6
}
